import { IPageShellState, ISetPageShellAction } from "./types";
import ActionTypes from '../../../constants/ActionTypes';

const initialState: IPageShellState = {
  data: {
    header: {
      genericLinks: [],
      item: {},
    },
    footer: {},
    login: {}
  }
};
const pageShellReducer = (
  state = initialState,
  action: ISetPageShellAction,
): IPageShellState => {
  switch (action.type) {
  case ActionTypes.PAGE_SHELL.SET:
    const { header, footer, login } = action.payload.data;
    return {
      ...state,
      data: {
        header: {
          genericLinks: header.genericLinks,
          item: header.item,
        },
        footer,
        login,
      },
    };
  case ActionTypes.PAGE_SHELL.SET_LOGIN_DATA:
    return {
      ...state,
      data: {
        ...state.data,
        login: action.payload
      }
    };
  }

  return state;
};

export default pageShellReducer;
